<script>
import Layout from '@layouts/main'
import HeaderPage from '@/src/components/register/header-page.vue'
import clienteMixin from '@/src/mixins/clienteMixin'
import orcamentoMixin from '@/src/mixins/orcamentoMixin'
import moment from 'moment'
import alertMixin from '@/src/mixins/alertMixin'
import agendaMixin from '@/src/mixins/agendaMedicaMixin'
import GrupoService from '@/src/services/grupo'

export default {
  components: { Layout, HeaderPage },
  mixins: [orcamentoMixin, clienteMixin, alertMixin, agendaMixin],
  data() {
    return {
      pageTitles: {
        title: 'Orçamentos',
      },
      selectMode: 'multi',
      filter: '',
      onFilter: ['cliente.nome'],
      viewProcedureOptions: [
        {
          key: 'descricao',
          label: 'Procedimentos',
          class: 'size-col-30',
        },
      ],
      viewProcedureFormOptions: [
        {
          key: 'procedimento',
          label: 'Procedimentos',
        },
      ],
      viewOptions: [
        {
          key: 'procedimento',
          label: 'Procedimentos',
          class: 'size-col-30',
        },
        {
          key: 'total',
          label: 'Valor',
          class: 'size-col-20',
        },
        {
          key: 'conveniado.nome',
          label: 'Conveniado',
          class: 'size-col-20',
        },
        {
          key: 'marcacao',
          label: 'Marcação',
          class: 'size-col-10',
        },
      ],
      viewOrcamento: [],
      orcamentosList: [],
      form: {
        data: new Date(),
        orcamentos: [],
        total: {},
      },
      selectedClient: {},
      formOpen: true,
      orcamentoLoading: false,
      orcamentoKeys: [],
      formAgendamentoCliente: '',
      filteredClientes: [],
      showClienteFilter: false,
      grupos: [],
      orcamentosFilter: [],
      orcamentosByGroup: [],
      procedimento: '',
      modalDel: false,
      itemId: '',
      orcamentoSelected: {},
      checkboxSelected: [],
      dataAgendamento: '',
      isDataAgendamento: false,
      usuario: this.$store.state.auth.currentUser.usuario,
    }
  },
  computed: {
    SumTotal() {
      return 10
    },
  },
  watch: {
    procedimento() {
      const searchValue = this.procedimento.trim().toLowerCase()

      if (searchValue.length >= 3) {
        this.orcamentosFilter = this.orcamentosByGroup.filter((orcamento) =>
          orcamento.procedimento.toLowerCase().includes(searchValue)
        )
      } else {
        this.orcamentosFilter = this.orcamentosByGroup.slice(0, 50)
      }
      this.selectRows()
      setTimeout(() => {
        this.selectRows()
      }, 300)
    },
    grupo() {
      this.getConveniados()
      this.gerOrcamento()
    },
    formAgendamentoCliente() {
      this.filterCliente(this.formAgendamentoCliente)
      this.showClienteFilter = true
    },
  },
  async created() {
    this.orcamentoLoading = true

    await this.listando();
    await this.loadGrupos();
    await this.getConveniadosSelect();

    this.orcamentoLoading = false
  },

  methods: {
    applyFilter() {
      this.orcamentoLoading = true;
      this.currentFilter = this.filter;

    },
    showProcedures(orcamentoSelected) {
      this.orcamentoSelected = orcamentoSelected
      this.$bvModal.show('view-procedure')
    },
    filterByGroup() {
      this.orcamentosByGroup = this.orcamentos.filter((i) => {
        return i.grupo
          ? (i.grupo._id ? i.grupo._id.toString() : i.grupo._id) === this.grupo
          : false
      })
      this.orcamentosFilter = this.orcamentosByGroup
    },
    async getConveniadosSelect() {
      try {
        const response = await this.loadConveniadosBySelect();
        this.conveniados = response;
      } catch (error) {
        console.error("Erro ao carregar conveniados:", error);
      }
    },
    getConveniados() {
      this.orcamentoFields = [
        {
          key: 'index',
          label: '#',
        },
        {
          key: 'select',
          label: '',
        },
        {
          key: 'procedimento',
          label: 'Procedimento',
        },
      ]

      this.loadConveniados(this.grupo, true).then((conveniados) => {
        this.conveniados = conveniados
        conveniados.map((conveniado) => {
          this.orcamentoFields.push({
            key: `${conveniado._id}`,
            label: conveniado.nome,
          })
        })
      })
    },
    gerOrcamento() {
      this.orcamentoLoading = true
      this.orcamentos = []
      this.orcamento(
        this.grupo,
        this.selectedClient.plano ? this.selectedClient.plano._id : ''
      )
        .then((response) => {
          response.data.map((item) => {
            let precos = {}
            item.conveniado.map((cur) => {
              precos[`${cur._id}`] = this.precoPorPlano(cur.plano)
            })
            this.orcamentos.push({
              ...precos,
              procedimento: item._id ? item._id.descricao : '',
              grupo: item._id ? item._id.grupo : '',
              procedimentoId: item._id ? item._id._id : '',
            })
            this.form.orcamentos = []
          })
          this.filterByGroup()
        })
        .finally(() => {
          this.orcamentoLoading = false
        })
    },
    findCliente(id) {
      this.isLoading = true
      return this.findOneCliente(id).then((response) => {
        this.isLoading = false
        return response.data
      })
    },
    precoPorPlano(planos) {
      if (this.selectedClient.plano) {
        let plano =
          planos[
          planos.findIndex((i) =>
            i.plano
              ? i.plano.descricao === this.selectedClient.plano.descricao
              : false
          )
          ]
        return plano ? parseFloat(plano.preco) : 0
      } else return 0
    },
    Agendar(item) {
      this.isDataAgendamento = false;
      if (this.dataAgendamento == undefined || this.dataAgendamento.length == 0) {
        this.isDataAgendamento = true;
        return
      }
      let conveniado = this.conveniados[this.conveniados.findIndex((i) => i._id === item.conveniado._id)]

      let agendamento = {
        cliente: this.form.cliente._id,
        dependente: this.form.dependente,
        conveniado: conveniado,
        procedimento: item.procedimento,
        valor: item.total,
        dataHora: this.dataAgendamento
      }

      this.orcamentoLoading = true

      this.registerAgendaMedica(agendamento)
        .then(async (response) => {
          this.orcamentoLoading = false
          this.$bvModal.hide('view-orcamento')
          this.form.status = 'marcado'
          await this.updateOrcamento(this.form._id, this.form)
          this.$router.push({
            path: '/agenda/agenda-medica',
            query: { agendamento: response.data._id },
          })
        })
        .catch((error) => {
          this.errorMessage(error.response.data.message ? error.response.data.message : 'Ocorreu um erro inesperado.')
          this.orcamentoLoading = false
        })
    },
    loseFocus() {
      setTimeout(() => {
        this.showClienteFilter = false
      }, 100)
    },
    findDependente(id, orcamento) {
      if (!orcamento || !orcamento.cliente) {
        console.error('Orçamento ou cliente não definido');
        return null;
      }

      let cliente = orcamento.cliente;

      if (!Array.isArray(cliente.dependentes) || cliente.dependentes.length === 0) {
        console.error('Cliente sem dependentes ou campo dependentes não é um array');
        return cliente.nome;
      }

      const index = cliente.dependentes.findIndex(i => i._id === id);


      if (index === -1) {
        console.error('Dependente não encontrado');
        return cliente.nome;
      }

      const dependente = cliente.dependentes[index];

      return dependente ? dependente.dependente : cliente.nome;
    },
    async selectCliente(cliente) {
      if (cliente['tipo'] === 'dependente') {
        this.form.dependente = cliente
        this.form.cliente = cliente.titular
      } else {
        this.form.cliente = cliente._id
        delete this.form.dependente
      }
      this.formAgendamentoCliente = cliente.nome
      this.selectedClient = await this.findCliente(this.form.cliente)
      setTimeout(() => {
        this.showClienteFilter = false
        if (this.grupo) this.gerOrcamento()
      }, 100)
    },
    filterCliente(filter) {
      if (!filter) {
        this.filteredClientes = this.clientes.slice(0, 4)
        return
      }
      this.filteredClientes = this.clientes
        .filter((i) => {
          return (
            (i.nome
              ? i.nome.toLowerCase().includes(filter.toLowerCase())
              : false) ||
            (i.cartao
              ? i.cartao.toLowerCase().includes(filter.toLowerCase())
              : false)
          )
        })
        .slice(0, 4)
    },
    async loadGrupos() {
      try {
        this.grupos = [];
        const resposta = await GrupoService.list();
        resposta.data.forEach(item => {
          this.grupos.push({
            value: item._doc._id,
            text: item._doc.grupo,
          });
        });
      } catch (error) { console.error("Erro ao carregar grupos:", error); }
    },
    formOpenFunc() {
      this.formOpen = !this.formOpen
      this.form = {
        data: new Date(),
        orcamentos: [],
        total: {},
      }
      this.grupo = null
      this.procedimento = ''
      this.formAgendamentoCliente = ''
      this.showClienteFilter = false
    },
    getRouteUser() {
      let clienteId = this.$route.query.cliente
      if (clienteId) {
        let cliente =
          this.clientes[this.clientes.findIndex((i) => i._id === clienteId)]
        this.selectCliente(cliente)
        this.formOpen = false
      }
    },
    async listando() {
      try {
        this.orcamentosList = [];
        this.orcamentosList = await this.loadOrcamentos();
      } catch (error) {
        this.errorMessage('Ops... Não conseguimos atender sua solicitação :(');
      }
    },
    async listandoByFilter() {
      try {
        this.orcamentoLoading = true;
        this.orcamentosList = [];
        this.orcamentosList = await this.loadOrcamentosByFilter(this.filter);
        this.orcamentoLoading = false;
      } catch (error) {
        this.orcamentoLoading = false;
        this.errorMessage('Ops... Não conseguimos atender sua solicitação :(');
      }
    },
    listandoClientes() {
      this.loadClientesBySelectByText(this.formAgendamentoCliente)
        .then((clientes) => {
          this.clientes = []
          for (let cliente of clientes) {
            this.clientes.push(cliente)
            for (let dependente of cliente.dependentes) {
              dependente['nome'] = dependente.dependente
              dependente['tipo'] = 'dependente'
              dependente['titular'] = cliente._id
              this.clientes.push(dependente)
            }
          }
          this.filterCliente(this.formAgendamentoCliente)
          this.getRouteUser()
        })
        .catch(() => {
          this.errorMessage('Ops... Não conseguimos atender sua solicitação :(')
        })
    },

    onRowSelected(item) {
      const itemIndex = this.form.orcamentos.findIndex(i => i.procedimentoId === item.procedimentoId);

      if (itemIndex >= 0) {
        this.form.orcamentos.splice(itemIndex, 1);
      } else {
        const itemExists = this.form.orcamentos.some(i => i.procedimentoId === item.procedimentoId);
        if (!itemExists) {
          this.form.orcamentos.push(item);
        }
      }
    },
    selectRows() {
      this.form.orcamentos.map((item) => {
        let checkIfHasSelected = this.orcamentosFilter.findIndex((i) => i.procedimentoId === item.procedimentoId)
        if (checkIfHasSelected >= 0)
          this.$refs.orcamentosTable.selectRow(checkIfHasSelected)
      })
    },
    handleCreate() {
      if (!this.form.dependente) this.form.dependente

      this.orcamentoLoading = true
      this.registerOrcamento(this.form)
        .then(() => {
          this.orcamentoLoading = false
          this.formOpenFunc()
          this.listando()
          this.getConveniadosSelect()
        })
        .catch(() => {
          this.errorMessage('Ops... Não conseguimos atender sua solicitação :(')
          this.orcamentoLoading = false
        })
    },
    modalDelete(item) {
      this.modalDel = true
      this.itemId = item
    },
    async handleDelete() {
      try {
        await this.deleteOrcamento(this.itemId)
        this.successMessage('Orçamento Deletado com sucesso')
        this.modalDel = false
        this.listando()
      } catch (error) {
        this.errorMessage(error)
      }
    },
    validForm() {
      if (!this.form.cliente) {
        this.errorMessage('Selecione um cliente para o orçamento')
        return
      }
      this.form._id ? this.handleEdit() : this.handleCreate()
    },
    sum(label) {
      let sum = this.form.orcamentos.reduce((a, acc) => {
        return (!isNaN(acc[label]) ? acc[label] : 0) + a
      }, 0)

      this.form.total[label] = sum
      return sum
    },
    formatDate(date) {
      if (date) return moment(date).format('DD/MM/YYYY')
    },
    modalView(orcamento) {
      this.isDataAgendamento = false;
      this.dataAgendamento = '';
      this.form = orcamento
      this.viewOrcamento = []
      if (!this.form.total) {
        this.form.total = {}
        this.form.orcamentos.map((orcamento) => {
          let orcamentoKeys = Object.keys(orcamento)
          this.sum(orcamentoKeys[0])
        })
      }
      this.orcamentoKeys = Object.keys(this.form.total)
      for (let conveniado of Object.keys(orcamento.total)) {
        let procedimentos = orcamento.orcamentos.filter((i) => {
          return i[conveniado]
        })
        let procedimento = procedimentos.map((i) => {
          return { descricao: i.procedimento, _id: i.procedimentoId }
        })
        if (procedimento.length) {
          let orcamentoInfo =
            this.conveniados[
            this.conveniados.findIndex((i) => i._id === conveniado)
            ]
          this.viewOrcamento.push({
            procedimento,
            total: `R$ ${orcamento.total[conveniado].toFixed(2)}`,
            conveniado: orcamentoInfo,
          })
        }
      }
      this.$bvModal.show('view-orcamento')
    },
  },
}
</script>

<template>
  <Layout :is-loading="orcamentoLoading">
    <div class="bloco">
      <HeaderPage :pageTitles="pageTitles" :formOpen="formOpen" @onClick="formOpenFunc()" />
      <div v-if="formOpen">
        <div class="col-md-4 d-flex">
          <b-input-group>
            <b-form-input id="filter" v-model="filter" type="text" placeholder="Pesquisar..."></b-form-input>

            <b-input-group-append>
              <b-button variant="info" @click="listandoByFilter">Filtrar</b-button>
            </b-input-group-append>
          </b-input-group>
        </div>
        <div class="row">
          <div class="col d-flex flex-column">
            <b-table :fields="orcamentoListFields" :items="orcamentosList">
              <template v-slot:cell(cliente)="row">
                {{
    row.item.dependente
      ? findDependente(row.item.dependente, row.item)
      : row.item.cliente
        ? row.item.cliente.nome
        : ''
  }}
              </template>
              <template v-slot:cell(data)="row">
                {{ formatDate(row.item.data) }}
              </template>
              <template v-slot:cell(actions)="row">
                <button v-b-tooltip.hover title="Visualizar" type="button" class="btn btn-light"
                  @click="modalView(row.item)">
                  <i class="uil uil-eye"></i>
                </button>
                <button v-if="!(usuario.tipo == 'verificador')" v-b-tooltip.hover title="Deletar" type="button"
                  class="btn btn-light" @click="modalDelete(row.item._id)">
                  <i class="uil uil-trash-alt"></i>
                </button>
              </template>
            </b-table>
          </div>
        </div>
      </div>
      <div v-else>
        <div class="row">
          <div class="col">
            <div class="row">
              <div class="col-8">
                <b-form-group label="Cliente">
                  <b-form-input @focus="showClienteFilter = true" name="filterCliente" v-model="formAgendamentoCliente"
                    @input="listandoClientes"></b-form-input>
                  <div class="filtered-select" v-if="showClienteFilter">
                    <ul>
                      <li v-for="cliente of filteredClientes" :key="cliente._id" @click="selectCliente(cliente)">{{
    cliente.nome
  }}</li>
                    </ul>
                  </div>
                </b-form-group>
              </div>
              <div class="col-8">
                <b-form-group label="Grupo">
                  <b-form-select v-model="grupo" :options="grupos">
                  </b-form-select>
                </b-form-group>
              </div>
              <div class="col-8">
                <b-form-group label="Procedimento">
                  <b-form-input v-model="procedimento" :disabled="!grupo || !form.cliente"></b-form-input>
                </b-form-group>
              </div>

              <div class="col-3">
                <b-form-group label="Data">
                  <b-form-datepicker disabled v-model="form.data">
                    <template v-slot:button-content>
                      <b-icon icon="calendar" variant="primary"></b-icon>
                    </template>
                  </b-form-datepicker>
                </b-form-group>
              </div>

              <div class="col d-flex align-items-center">
                <b-button class="mt-2" @click="$bvModal.show('view-procedure-form')">
                  Gerar Lista
                </b-button>
              </div>

            </div>
          </div>
        </div>

        <div style="height: 500px; overflow-y: scroll" v-if="grupo && form.cliente">
          <b-table ref="orcamentosTable" selectable :select-mode="selectMode" :fields="orcamentoFields"
            :items="orcamentosFilter">
            <template slot="cell(select)" slot-scope="data">
              <template>
                <span aria-hidden="true" @change="onRowSelected(data.item)">
                  <b-form-checkbox v-model="data.item.select"></b-form-checkbox>
                </span>
                <span class="sr-only">Selected</span>
              </template>
            </template>

            <template #foot()="data">
              <i>{{ data.label }}</i>
            </template>
          </b-table>
        </div>

        <div v-if="!orcamentoLoading" class="d-flex mt-3">
          <div class="col d-flex" v-for="(item, i) of orcamentoFields" :key="i">
            <p class="text-right" v-if="i === 1">Valor Total</p>
            <span v-if="i > 2">
              <b-form-input class="text-right" type="text" disabled :value="sum(item.key)"></b-form-input>
            </span>
          </div>
        </div>

        <div class="row justify-content-between">
          <b-button @click="validForm"> Fechar orçamento </b-button>
        </div>

      </div>
    </div>

    <b-modal id="view-procedure" size="md" :title="orcamentoSelected.conveniado ? orcamentoSelected.conveniado.nome : ''
    " hide-footer>
      <b-table :items="orcamentoSelected.procedimento" :fields="viewProcedureOptions"></b-table>
    </b-modal>

    <b-modal id="view-orcamento" size="xl" centered title="Confirmar Agendamento" hide-footer>
      <b-alert v-show="isDataAgendamento" variant="danger" show>Para agendar é necessário selecionar a data de
        agendamento</b-alert>
      <b-form-datepicker id="dt-marcacao" v-model="dataAgendamento" placeholder="Selecione a data de agendamento"
        :date-format-options="{
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
  }" locale="pt-br">
        <template v-slot:button-content>
          <b-icon icon="calendar" variant="primary"></b-icon>
        </template>
      </b-form-datepicker>
      <b-table :items="viewOrcamento" :fields="viewOptions">
        <template v-slot:cell(procedimento)="row">
          <b-button @click="showProcedures(row.item)" variant="info">Visualizar Procedimentos</b-button>
        </template>
        <template v-slot:cell(data)="row">

        </template>
        <template v-slot:cell(marcacao)="row" v-if="!(usuario.tipo == 'verificador')">
          <button v-b-tooltip.hover title="Marcar Agendamento" type="button" class="btn btn-light"
            @click="Agendar(row.item)">
            <i class="uil uil-folder-plus"></i>
          </button>
        </template>
      </b-table>
    </b-modal>
    <b-modal v-model="modalDel" title="Aviso" title-class="font-18">
      <p>Tem certeza que deseja excluir este registro?</p>
      <template v-slot:modal-footer>
        <b-button variant="light" @click="modalDel = false">Não</b-button>
        <b-button variant="danger" @click="handleDelete">Sim</b-button>
      </template>
    </b-modal>
    <b-modal id="view-procedure-form" size="md" hide-footer>
      <b-table :items="this.form.orcamentos" :fields="viewProcedureFormOptions"></b-table>
    </b-modal>
  </Layout>
</template>



<style src="../style.scss" lang="scss"></style>
<style scoped>
.filtered-select {
  position: absolute;
  background-color: white;
  width: 96%;
  left: 0;
  z-index: 20;
}

.filtered-select ul {
  list-style: none;
  padding-left: 19px;
}

.filtered-select ul li {
  padding-top: 10px;
  padding-left: 10px;
  font-size: 14px;
  border-radius: 2%;
  justify-content: center;
}

.filtered-select ul li:hover {
  background-color: #0088a8;
  color: white;
  transition: 200ms;
}
</style>
